import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

export const UndreadMessageSnackbar = ({ position, undreadMessages, ...rest }) => {
  const [open, setOpen] = React.useState(undreadMessages > 0);

  /*   useEffect(() => {

  }, []); */

  useEffect(() => {
    if (undreadMessages > 0 && open == false) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [undreadMessages]);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const { vertical, horizontal } = position;
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical,
          horizontal,
        }}
        open={open}
        onClose={handleClose}
        style={{ animation: "bounce 1.5s forwards infinite" }}
        message={
          <div style={{ display: "flex", alignItems: "center" }}>
            <MailOutlineIcon className="primary-text" style={{ marginRight: 10 }} />
            <span className="primary-text" style={{ marginRight: 10 }}>
              {undreadMessages}
            </span>
            <SystemLabel name="UndreadMessages" />
          </div>
        }
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </div>
  );
};
